import React from 'react';

const Footer = () => (
<footer className="footer">
	<p>© 2021 Arnican Pvt Ltd</p>

</footer>
);

export default Footer;

